import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=20618972&scoped=true"
import script from "./Tree.ts?vue&type=script&lang=ts&external"
export * from "./Tree.ts?vue&type=script&lang=ts&external"
import style0 from "./Tree.vue?vue&type=style&index=0&id=20618972&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20618972",
  null
  
)

export default component.exports